module.exports = __webpack_public_path__ + "img/ZhongGanMicro.c8660b79.jpg";